export const config = {
    appId: '5982e64d-2298-44b7-bd49-01f08c1dc2df',
    groupGuid: 'bf9c3043-cd57-4b65-9110-4980319243e8',
    redirectUri: `${process.env.REACT_APP_FRONTEND_URL}`,
    scopes: [
        'user.read'
    ]
};